var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import AiReviewLoader from './components/overview/AiReviewLoader';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import { SOURCE_DOCUMENT_LABELS } from './components/overview/OverviewFieldMatchSection';
import OverviewRuleGridCard from './components/overview/OverviewRuleGridCard';
import OverviewSourceDocuments from './components/overview/OverviewSourceDocuments';
import OverviewReviewHeader, { ACCEPT_REVIEW_NEXT_STATUS, DOCS_BACK_MISSING_INFO_STATUS } from './components/overview/OverviewReviewHeader';
import CustomTextarea from '../../components/FormComponents/TextAreaField';
import StatusTransitionDialog from './components/overview/StatusTransitionDialog';
import { useDocsBackReasons } from './components/useDocsBackReasons';
import { saveContractReasons } from './components/contractReasonsService';
import DocsBackReasonsForm, { EMPTY_DOCS_BACK_REASONS, getDocsBackReasonsError } from './components/DocsBackReasonsForm';
import { AI_REVIEW_FONT_SIZE, AI_REVIEW_FONT_VAR, REVIEW_GRID_COLUMNS } from './components/overview/aiReviewScale';
import { extractApplicationDocuments, findSourceDocuments, } from './postDocsAiReview_service';
var iconPerson = React.createElement(PersonOutlineOutlinedIcon, null);
var iconLocation = React.createElement(PlaceOutlinedIcon, null);
var iconSerial = React.createElement(NumbersOutlinedIcon, null);
var iconAmount = React.createElement(PaidOutlinedIcon, null);
var iconCalendar = React.createElement(CalendarTodayOutlinedIcon, null);
var iconSignature = React.createElement(DrawOutlinedIcon, null);
var iconCard = React.createElement(BadgeOutlinedIcon, null);
var iconState = React.createElement(MapOutlinedIcon, null);
var signatureSource = function (docs, borrower) {
    return docs.DocPkg && docs.DocPkg.IsSigned !== undefined ? docs.DocPkg : (borrower !== null && borrower !== void 0 ? borrower : {});
};
var isSignatureDateMissing = function (_a) {
    var _b;
    var docs = _a.docs, borrower = _a.borrower, rulePassed = _a.rulePassed;
    var source = signatureSource(docs, borrower);
    var signed = (_b = parseSignedFlag(source.IsSigned)) !== null && _b !== void 0 ? _b : rulePassed;
    return signed && !formatDisplayDate(source.SignatureDate);
};
var SIGNATURE_DATE_MISSING_REASON = 'Date of Signature Missing';
var EMPTY_DATE_PLACEHOLDER = '--/--/--';
var parseSignedFlag = function (raw) {
    var text = String(raw !== null && raw !== void 0 ? raw : '').trim();
    if (!text || /^(n\/a|na\b|unknown|none)/i.test(text))
        return undefined;
    if (/^(n\b|no\b|false|0$|not\b|un-?signed|missing|absent)/i.test(text))
        return false;
    if (/^(y\b|yes\b|true|1$|signed|present)/i.test(text))
        return true;
    return undefined;
};
var formatDisplayDate = function (raw) {
    if (!raw)
        return undefined;
    var isoDate = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
    if (isoDate)
        return "".concat(isoDate[2], "/").concat(isoDate[3], "/").concat(isoDate[1]);
    var usDate = /^(\d{1,2})[-/](\d{1,2})[-/](\d{2}|\d{4})(?!\d)/.exec(raw.trim());
    if (usDate) {
        var month = Number(usDate[1]);
        var day = Number(usDate[2]);
        if (month < 1 || month > 12 || day < 1 || day > 31)
            return raw;
        var year = usDate[3].length === 2 ? "20".concat(usDate[3]) : usDate[3];
        return "".concat(usDate[1].padStart(2, '0'), "/").concat(usDate[2].padStart(2, '0'), "/").concat(year);
    }
    var parsed = new Date(raw);
    return Number.isNaN(parsed.getTime())
        ? raw
        : parsed.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};
var formatAmount = function (value) {
    var numeric = typeof value === 'number' ? value : parseFloat(value);
    if (Number.isNaN(numeric))
        return String(value !== null && value !== void 0 ? value : '--');
    return numeric.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
var RULE_DEFS = [
    { rule: 'Borrower Name', title: 'Customer Name', ruleText: 'Borrower name must match across all documents', passLabel: 'Name Matches', failLabel: 'Name Not Matched', label: 'Name:', icon: iconPerson, systemFallback: function (b) { return b === null || b === void 0 ? void 0 : b.BorrowerName; } },
    { rule: 'Address', title: 'Customer Address', ruleText: 'Address must match across all documents', passLabel: 'Address Matches', failLabel: 'Address Not Matched', label: 'Main Address:', icon: iconLocation, systemFallback: function (b) { return b === null || b === void 0 ? void 0 : b.BorrowerAddress; } },
    { rule: 'Serial Number', title: 'Serial Number', ruleText: 'Equipment serial must match the Doc Package', passLabel: 'Serial Number Matches', failLabel: 'Serial Number Not Matched', label: 'Serial Number', icon: iconSerial, systemFallback: function (b) { var _a, _b; return (_b = (_a = b === null || b === void 0 ? void 0 : b.Equipment) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.SerialNumber; } },
    { rule: 'State of Residence', title: 'State of Residence', ruleText: 'State of residence must match across all documents', passLabel: 'State Matches', failLabel: 'State Not Matched', label: 'State', icon: iconState, systemFallback: function (b) { return b === null || b === void 0 ? void 0 : b.StateOfResidence; } },
    { rule: 'Signature', title: 'Doc Signed', ruleText: 'Doc Package must be signed by borrower', passLabel: 'Doc Signed', failLabel: 'Doc Not Signed', label: 'Signed', icon: iconSignature, systemFallback: function (b) { return b === null || b === void 0 ? void 0 : b.IsSigned; }, indicatorFor: SOURCE_DOCUMENT_LABELS.documentPackage, indicatorPrefix: 'Signature', indicatorPassLabel: 'Signed', indicatorFailLabel: 'Not Signed',
        indicatorPassed: function (context) {
            var _a;
            var docs = context.docs, borrower = context.borrower, rulePassed = context.rulePassed;
            var signed = (_a = parseSignedFlag(signatureSource(docs, borrower).IsSigned)) !== null && _a !== void 0 ? _a : rulePassed;
            return signed && !isSignatureDateMissing(context);
        },
        indicatorDetail: function (_a) {
            var docs = _a.docs, borrower = _a.borrower;
            return formatDisplayDate(signatureSource(docs, borrower).SignatureDate);
        } },
    { rule: 'Amount', title: 'Amount', ruleText: 'Invoice amount must match the Doc Package', passLabel: 'Amount Matches', failLabel: 'Amount Not Matched', label: 'Amount', icon: iconAmount, format: formatAmount, systemFallback: function (b) { return b === null || b === void 0 ? void 0 : b.AmountFinanced; } },
    { rule: 'Invoice Date', title: 'Invoice Date', ruleText: 'Invoice date must be within 20 days', passLabel: 'Valid Invoice Date', failLabel: 'Invalid Invoice Date', label: 'Invoice Date', icon: iconCalendar, indicatorPassLabel: 'Valid Invoice', indicatorFailLabel: 'Outdated Invoice', indicatorFor: SOURCE_DOCUMENT_LABELS.invoice, indicatorShowsValue: true, indicatorNeedsValue: true },
    { rule: 'License Expiry', title: "License Validity", ruleText: "Driver's license must be valid through contract date", passLabel: 'License Not Expired', failLabel: 'License Expired', label: 'Expiry Date', icon: iconCard, indicatorPassLabel: 'Valid License', indicatorFailLabel: 'Expired License', indicatorFor: SOURCE_DOCUMENT_LABELS.driversLicense, indicatorShowsValue: true, indicatorNeedsValue: true },
];
var genericRuleDef = function (rule) { return ({
    rule: rule,
    title: "".concat(rule, " check"),
    passLabel: "".concat(rule, " Verified"),
    failLabel: "".concat(rule, " Not Verified"),
    label: rule,
    icon: iconCard,
}); };
var getRuleDef = function (rule) { var _a; return (_a = RULE_DEFS.find(function (def) { return def.rule === rule; })) !== null && _a !== void 0 ? _a : genericRuleDef(rule); };
var sectionIdFor = function (rule, index) { return "ai-review-section-".concat(index, "-").concat(rule.toLowerCase().replace(/[^a-z0-9]+/g, '-')); };
var META_KEYS = ['Status', 'Reason'];
var pickExtractedValue = function (doc, format) {
    if (!doc)
        return undefined;
    var key = Object.keys(doc).find(function (k) { return !META_KEYS.includes(k); });
    var raw = key ? doc[key] : undefined;
    if (raw === undefined || raw === null || raw === '')
        return undefined;
    if (format)
        return format(raw);
    return Array.isArray(raw) ? raw.join(', ') : String(raw);
};
var buildFieldMatchSections = function (result, sourceDocuments, onOpenDocument) {
    var _a, _b, _c, _d;
    var borrower = (_b = (_a = result.documentPackage) === null || _a === void 0 ? void 0 : _a.Borrowers) === null || _b === void 0 ? void 0 : _b[0];
    var openerFor = function (doc) { return (doc && onOpenDocument ? function () { return onOpenDocument(doc); } : undefined); };
    var sections = ((_d = (_c = result.validation) === null || _c === void 0 ? void 0 : _c.Validations) !== null && _d !== void 0 ? _d : []).map(function (validation, index) {
        var _a, _b, _c, _d, _e, _f, _g;
        var def = getRuleDef(validation.Rule);
        var docs = (_a = validation.Documents) !== null && _a !== void 0 ? _a : {};
        var isPass = validation.OverallStatus === 'Pass';
        var indicatorContext = { docs: docs, borrower: borrower, rulePassed: isPass };
        var passed = def.indicatorPassed ? def.indicatorPassed(indicatorContext) : isPass;
        var signatureDateMissing = def.rule === 'Signature' && isSignatureDateMissing(indicatorContext);
        var entries = [
            { doc: docs.Invoice, sourceLabel: SOURCE_DOCUMENT_LABELS.invoice, file: sourceDocuments.dealerInvoice },
            { doc: docs.DL, sourceLabel: SOURCE_DOCUMENT_LABELS.driversLicense, file: sourceDocuments.driverLicense },
        ]
            .filter(function (_a) {
            var doc = _a.doc;
            return doc && doc.Status !== 'N/A';
        })
            .map(function (_a) {
            var _b;
            var doc = _a.doc, sourceLabel = _a.sourceLabel, file = _a.file;
            return ({
                icon: def.icon,
                label: def.label,
                value: (_b = pickExtractedValue(doc, def.format)) !== null && _b !== void 0 ? _b : '--',
                sourceLabel: sourceLabel,
                mismatched: doc.Status !== 'Pass',
                reason: doc.Reason,
                onOpen: openerFor(file),
            });
        });
        var systemRaw = (_b = pickExtractedValue(docs.DocPkg, def.format)) !== null && _b !== void 0 ? _b : (def.systemFallback ? def.systemFallback(borrower) : undefined);
        var systemValue = systemRaw === undefined || systemRaw === null || systemRaw === ''
            ? '--'
            : def.format && typeof systemRaw !== 'string' ? def.format(systemRaw) : String(systemRaw);
        return {
            id: sectionIdFor(validation.Rule, index),
            title: def.title,
            icon: def.icon,
            label: def.label,
            systemValue: systemValue,
            badgeTone: passed ? 'matched' : 'review',
            reason: signatureDateMissing ? SIGNATURE_DATE_MISSING_REASON : validation.Reason,
            ruleLabel: def.ruleText,
            systemPresent: Boolean(docs.DocPkg) && ((_c = docs.DocPkg) === null || _c === void 0 ? void 0 : _c.Status) !== 'N/A',
            indicatorFor: def.indicatorFor,
            indicatorPrefix: def.indicatorPrefix,
            indicatorNeedsValue: def.indicatorNeedsValue,
            indicatorLabel: passed || signatureDateMissing ? ((_d = def.indicatorPassLabel) !== null && _d !== void 0 ? _d : def.passLabel) : ((_e = def.indicatorFailLabel) !== null && _e !== void 0 ? _e : def.failLabel),
            indicatorValueWarning: signatureDateMissing,
            indicatorValue: signatureDateMissing
                ? EMPTY_DATE_PLACEHOLDER
                : def.indicatorDetail
                    ? (passed ? def.indicatorDetail(indicatorContext) : undefined)
                    : def.indicatorShowsValue
                        ? ((_g = (_f = entries.find(function (entry) { return entry.sourceLabel === def.indicatorFor && entry.value !== '--'; })) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : (def.indicatorFor === SOURCE_DOCUMENT_LABELS.documentPackage && systemValue !== '--' ? systemValue : undefined))
                        : undefined,
            actionLabel: passed ? 'Ignore' : 'Update',
            sourceEntries: entries,
            onSourceOpen: openerFor(sourceDocuments.documentPackage),
        };
    });
    return sections;
};
var EXTRACT_CACHE_MAX_ENTRIES = 5;
var extractRunCache = new Map();
var runKeyFor = function (TxAspireOId, documents) {
    return "".concat(TxAspireOId, "|").concat(documents.map(function (doc) { return doc.DocumentIdentifier; }).join(','));
};
var USE_LEGACY_DOCS_BACK_REASON_UI = true;
var BacklogPostDocsAI = function (_a) {
    var _b;
    var TxAspireOId = _a.TxAspireOId, documents = _a.documents, onDocumentOpen = _a.onDocumentOpen, onRefreshDocuments = _a.onRefreshDocuments, contractAspireId = _a.contractAspireId, _c = _a.canDecide, canDecide = _c === void 0 ? false : _c, statusReasons = _a.statusReasons, onAcceptReview = _a.onAcceptReview, onDocsBackMissingInfo = _a.onDocsBackMissingInfo;
    var _d = useState(null), extractResult = _d[0], setExtractResult = _d[1];
    var _e = useState(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), hasError = _f[0], setHasError = _f[1];
    var _g = useState(0), retryNonce = _g[0], setRetryNonce = _g[1];
    var activeRunKeyRef = useRef(null);
    var forceFreshRunRef = useRef(false);
    var shownRunKeyRef = useRef(null);
    var onDocumentOpenRef = useRef(onDocumentOpen);
    onDocumentOpenRef.current = onDocumentOpen;
    var openDocument = useCallback(function (doc) { var _a; return (_a = onDocumentOpenRef.current) === null || _a === void 0 ? void 0 : _a.call(onDocumentOpenRef, doc); }, []);
    useEffect(function () {
        if (!TxAspireOId || !documents || documents.length === 0)
            return;
        var runKey = runKeyFor(TxAspireOId, documents);
        activeRunKeyRef.current = runKey;
        if (shownRunKeyRef.current !== runKey) {
            setExtractResult(null);
            setHasError(false);
            setIsLoading(true);
        }
        shownRunKeyRef.current = runKey;
        var isRerun = forceFreshRunRef.current;
        if (isRerun) {
            extractRunCache.delete(runKey);
            forceFreshRunRef.current = false;
        }
        var promise = extractRunCache.get(runKey);
        if (!promise) {
            var run_1 = extractApplicationDocuments(TxAspireOId, documents, { rerun: isRerun });
            promise = run_1;
            if (extractRunCache.size >= EXTRACT_CACHE_MAX_ENTRIES) {
                var oldestKey = extractRunCache.keys().next().value;
                if (oldestKey !== undefined)
                    extractRunCache.delete(oldestKey);
            }
            extractRunCache.set(runKey, run_1);
            run_1.then(function (result) { if (!result && extractRunCache.get(runKey) === run_1)
                extractRunCache.delete(runKey); }, function () { if (extractRunCache.get(runKey) === run_1)
                extractRunCache.delete(runKey); });
        }
        promise
            .then(function (result) {
            if (activeRunKeyRef.current !== runKey)
                return;
            setExtractResult(result);
        })
            .catch(function () {
            if (activeRunKeyRef.current === runKey)
                setHasError(true);
        })
            .finally(function () {
            if (activeRunKeyRef.current === runKey)
                setIsLoading(false);
        });
        return function () {
            if (activeRunKeyRef.current === runKey)
                activeRunKeyRef.current = null;
        };
    }, [TxAspireOId, documents, retryNonce]);
    var _h = useState('accept'), decisionKey = _h[0], setDecisionKey = _h[1];
    var _j = useState(false), isDecisionOpen = _j[0], setIsDecisionOpen = _j[1];
    var _k = useState(''), legacyStatusReason = _k[0], setLegacyStatusReason = _k[1];
    var savedStatusReasons = (statusReasons !== null && statusReasons !== void 0 ? statusReasons : [])
        .map(function (reason) { return reason === null || reason === void 0 ? void 0 : reason.Value; })
        .filter(function (value) { return typeof value === 'string' && value.trim().length > 0; });
    var DECISIONS = {
        accept: {
            message: "Confirm the AI review and advance this application to ".concat(ACCEPT_REVIEW_NEXT_STATUS, "?"),
            newStatus: ACCEPT_REVIEW_NEXT_STATUS,
            onConfirm: onAcceptReview,
        },
        docsBack: {
            message: "Send this application back for missing information and move it to ".concat(DOCS_BACK_MISSING_INFO_STATUS, "?"),
            newStatus: DOCS_BACK_MISSING_INFO_STATUS,
            onConfirm: function () { return (onDocsBackMissingInfo ? onDocsBackMissingInfo(USE_LEGACY_DOCS_BACK_REASON_UI ? legacyStatusReason.trim() : undefined) : Promise.resolve(true)); },
        },
    };
    var decision = DECISIONS[decisionKey];
    var _l = useState(EMPTY_DOCS_BACK_REASONS), docsBackReasons = _l[0], setDocsBackReasons = _l[1];
    var isDocsBackDecision = decisionKey === 'docsBack';
    var _m = useDocsBackReasons(!USE_LEGACY_DOCS_BACK_REASON_UI && isDecisionOpen && isDocsBackDecision), predefinedReasons = _m.reasons, isLoadingReasons = _m.isLoading, reasonsLoadFailed = _m.hasFailed;
    var _o = useState(false), showDocsBackErrors = _o[0], setShowDocsBackErrors = _o[1];
    var closeDecision = function () {
        setIsDecisionOpen(false);
        setShowDocsBackErrors(false);
    };
    var _p = useState(false), isSubmittingDecision = _p[0], setIsSubmittingDecision = _p[1];
    var handleConfirmDecision = function () { return __awaiter(void 0, void 0, void 0, function () {
        var succeeded, reasonsSaved, _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (isSubmittingDecision)
                        return [2];
                    if (isDocsBackDecision && !USE_LEGACY_DOCS_BACK_REASON_UI && getDocsBackReasonsError(docsBackReasons)) {
                        setShowDocsBackErrors(true);
                        return [2];
                    }
                    setIsSubmittingDecision(true);
                    succeeded = false;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, , 9, 10]);
                    if (!(isDocsBackDecision && !USE_LEGACY_DOCS_BACK_REASON_UI)) return [3, 3];
                    return [4, saveContractReasons({ contractAspireId: contractAspireId, txAspireOId: TxAspireOId, status: DOCS_BACK_MISSING_INFO_STATUS, predefinedReasons: predefinedReasons, value: docsBackReasons })];
                case 2:
                    _a = _d.sent();
                    return [3, 4];
                case 3:
                    _a = true;
                    _d.label = 4;
                case 4:
                    reasonsSaved = _a;
                    _b = reasonsSaved;
                    if (!_b) return [3, 8];
                    if (!decision.onConfirm) return [3, 6];
                    return [4, decision.onConfirm()];
                case 5:
                    _c = _d.sent();
                    return [3, 7];
                case 6:
                    _c = true;
                    _d.label = 7;
                case 7:
                    _b = (_c);
                    _d.label = 8;
                case 8:
                    succeeded = _b;
                    return [3, 10];
                case 9:
                    setIsSubmittingDecision(false);
                    return [7];
                case 10:
                    if (!succeeded)
                        return [2];
                    closeDecision();
                    setDocsBackReasons(EMPTY_DOCS_BACK_REASONS);
                    setLegacyStatusReason('');
                    return [2];
            }
        });
    }); };
    var handleRerun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var latestDocuments, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!TxAspireOId)
                        return [2];
                    setExtractResult(null);
                    setHasError(false);
                    setIsLoading(true);
                    forceFreshRunRef.current = true;
                    if (!onRefreshDocuments) return [3, 2];
                    return [4, onRefreshDocuments()];
                case 1:
                    _a = _c.sent();
                    return [3, 3];
                case 2:
                    _a = null;
                    _c.label = 3;
                case 3:
                    latestDocuments = (_b = (_a)) !== null && _b !== void 0 ? _b : documents;
                    if (!latestDocuments || latestDocuments.length === 0) {
                        forceFreshRunRef.current = false;
                        setIsLoading(false);
                        return [2];
                    }
                    setRetryNonce(function (n) { return n + 1; });
                    return [2];
            }
        });
    }); };
    var handleRetry = function () {
        setHasError(false);
        setIsLoading(true);
        setRetryNonce(function (n) { return n + 1; });
    };
    var sourceDocuments = useMemo(function () { return findSourceDocuments(documents !== null && documents !== void 0 ? documents : []); }, [documents]);
    var reviewedDocuments = useMemo(function () {
        var toItem = function (label, doc) { return doc
            ? {
                label: label,
                fileName: doc.FileName || doc.DocumentIdentifier,
                onOpen: onDocumentOpen ? function () { return openDocument(doc); } : undefined,
            }
            : { label: label, fileName: '', missing: true }; };
        return [
            toItem(SOURCE_DOCUMENT_LABELS.documentPackage, sourceDocuments.documentPackage),
            toItem(SOURCE_DOCUMENT_LABELS.invoice, sourceDocuments.dealerInvoice),
            toItem(SOURCE_DOCUMENT_LABELS.driversLicense, sourceDocuments.driverLicense),
        ];
    }, [sourceDocuments, onDocumentOpen, openDocument]);
    var fieldMatchSections = useMemo(function () { return (extractResult ? buildFieldMatchSections(extractResult, sourceDocuments, onDocumentOpen ? openDocument : undefined) : []); }, [extractResult, sourceDocuments, onDocumentOpen, openDocument]);
    var cardSections = useMemo(function () { return fieldMatchSections.filter(function (section) { return !section.indicatorFor; }); }, [fieldMatchSections]);
    var sourceIndicators = useMemo(function () { return fieldMatchSections
        .filter(function (section) { return section.indicatorFor && (!section.indicatorNeedsValue || section.indicatorValue); })
        .map(function (section) {
        var _a;
        return ({
            documentLabel: section.indicatorFor,
            title: (_a = section.indicatorLabel) !== null && _a !== void 0 ? _a : section.title,
            prefix: section.indicatorPrefix,
            value: section.indicatorValue,
            valueWarning: section.indicatorValueWarning,
            matched: section.badgeTone === 'matched',
            reason: section.reason,
        });
    }); }, [fieldMatchSections]);
    if (isLoading) {
        return React.createElement(AiReviewLoader, { variant: "post" });
    }
    return (React.createElement(Box, { display: "flex", flexDirection: "column", gap: 2, sx: (_b = {}, _b[AI_REVIEW_FONT_VAR] = AI_REVIEW_FONT_SIZE, _b.fontFamily = function (theme) { return theme.typography.fontFamily; }, _b) },
        React.createElement(OverviewReviewHeader, { hasResults: fieldMatchSections.length > 0 && !hasError, canDecide: canDecide, lastRunAt: extractResult === null || extractResult === void 0 ? void 0 : extractResult.reviewedAt, onRerun: handleRerun, onAcceptReview: function () { setDecisionKey('accept'); setIsDecisionOpen(true); }, onDocsBackMissingInfo: function () { setDecisionKey('docsBack'); setIsDecisionOpen(true); } }),
        React.createElement(StatusTransitionDialog, { open: isDecisionOpen, message: decision.message, newStatus: decision.newStatus, maxWidth: isDocsBackDecision ? 'md' : 'xs', isSubmitting: isSubmittingDecision, onCancel: closeDecision, onConfirm: handleConfirmDecision },
            isDocsBackDecision && USE_LEGACY_DOCS_BACK_REASON_UI && (React.createElement(Box, { sx: { mb: 2 } },
                React.createElement(Typography, { variant: "body2", fontWeight: 600, sx: { mb: 1, color: '#E65E43' } }, "Contract Status Reason(s):"),
                savedStatusReasons.length > 0 ? (React.createElement(Box, { component: "ul", sx: { m: 0, pl: 2 } }, savedStatusReasons.map(function (value, index) { return (React.createElement(Typography, { component: "li", key: "".concat(value, "-").concat(index), variant: "body2", fontWeight: 500 }, value)); }))) : (React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "--")))),
            isDocsBackDecision && (React.createElement(Typography, { variant: "body2", fontWeight: 600, sx: { mb: 1, color: '#E65E43' } }, "Contract Status Reason(UDF):")),
            isDocsBackDecision && USE_LEGACY_DOCS_BACK_REASON_UI && (React.createElement(CustomTextarea, { fieldName: "StatusReason", value: legacyStatusReason, onChange: function (event) { return setLegacyStatusReason(event.target.value); }, placeholder: "Enter reason for status change", rows: 3, maxLength: 500 })),
            isDocsBackDecision && !USE_LEGACY_DOCS_BACK_REASON_UI && (React.createElement(DocsBackReasonsForm, { value: docsBackReasons, onChange: setDocsBackReasons, predefinedReasons: predefinedReasons, isLoadingReasons: isLoadingReasons, reasonsLoadFailed: reasonsLoadFailed, showErrors: showDocsBackErrors }))),
        fieldMatchSections.length > 0 && React.createElement(OverviewSourceDocuments, { documents: reviewedDocuments, indicators: sourceIndicators }),
        hasError ? (React.createElement(Stack, { alignItems: "flex-start", gap: 1 },
            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "We couldn't run the AI review for this application."),
            React.createElement(Button, { size: "small", variant: "outlined", onClick: handleRetry }, "Retry"))) : fieldMatchSections.length === 0 ? (React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "No AI review data available yet for this application.")) : (React.createElement(Box, { sx: {
                display: 'grid',
                gridTemplateColumns: REVIEW_GRID_COLUMNS,
                gap: '16px',
                alignItems: 'stretch',
            } }, cardSections.map(function (section, index) { return (React.createElement(OverviewRuleGridCard, __assign({ key: "".concat(section.title, "-").concat(index) }, section))); })))));
};
export default BacklogPostDocsAI;
